import { createAction, handleActions } from 'redux-actions';

const ACTIVE_SETTING_MENU = 'statusmenu/ACTIVE_SETTING_MENU';
const ACTIVE_SIDE_MENU = 'statusmenu/ACTIVE_SIDE_MENU';
const ACTIVE_QUICK_MENU = 'statusmenu/ACTIVE_QUICK_MENU';
const ACTIVE_FEEDBACK_MODAL = 'statusmenu/ACTIVE_FEEDBACK_MODAL';
const ACTIVE_SATISFY_MODAL = 'statusmenu/ACTIVE_SATISFY_MODAL';
const DISABLE_ALL_MENU = 'statusmenu/DISABLE_ALL_MENU';
const ACTIVE_MODAL = 'statusmenu/ACTIVE_MODAL';
const ACTIVE_INITIAL_MODAL = 'statusmenu/ACTIVE_INITIAL_MODAL';
const ACTIVE_EXIT_MODAL = 'statusmenu/ACTIVE_EXIT_MODAL';
const ACTIVE_CONVERSATION_GUIDE = 'statusmenu/ACTIVE_CONVERSATION_GUIDE';
const ACTIVE_SERVICE_GUIDE = 'statusmenu/ACTIVE_SERVICE_GUIDE';
const ACTIVE_ORGANIZATION = 'statusmenu/ACTIVE_ORGANIZATION';
const ACTIVE_EXPANDIMAGE = 'statusmenu/ACTIVE_EXPANDIMAGE';
const EXPANDIMAGE_URL = 'statusmenu/EXPANDIMAGE_URL';
const EXPANDIMAGE_ALT = 'statusmenu/EXPANDIMAGE_ALT';
const LOADING = 'statusmenu/LOADING';
const ACTIVE_ADDITIONAL = 'statusmenu/ACTIVE_ADDITIONAL';
const ACTIVE_SOSONG_GUIDE = 'statusmenu/ACTIVE_SOSONG_GUIDE';
const ACTIVE_SOSONG_FLOWCHART = 'statusmenu/ACTIVE_SOSONG_FLOWCHART';
const ACTIVE_TERM_SEARCH = 'statusmenu/ACTIVE_TERM_SEARCH';
const ACTIVE_FEEDBACK_RESPONSE_MODAL = 'statusmenu/ACTIVE_FEEDBACK_RESPONSE_MODAL';
const ACTIVE_SEND_BTN = 'statusmenu/ACTIVE_SEND_BTN';

export const isActiveSettingMenu = createAction(ACTIVE_SETTING_MENU);
export const isActiveSideMenu = createAction(ACTIVE_SIDE_MENU);
export const isActiveQuickMenu = createAction(ACTIVE_QUICK_MENU);
export const isActiveFeedbackModal = createAction(ACTIVE_FEEDBACK_MODAL);
export const isActiveFeedbackReponseModal = createAction(ACTIVE_FEEDBACK_RESPONSE_MODAL);
export const isActiveInitialModal = createAction(ACTIVE_INITIAL_MODAL);
export const isActiveExitModal = createAction(ACTIVE_EXIT_MODAL);
export const isACtiveSatisfyModal = createAction(ACTIVE_SATISFY_MODAL);
export const activeModal = createAction(ACTIVE_MODAL);
export const isActiveConversationGuideModal = createAction(ACTIVE_CONVERSATION_GUIDE);
export const isActiveServiceGuideModal = createAction(ACTIVE_SERVICE_GUIDE);
export const isActiveOrganizationModal = createAction(ACTIVE_ORGANIZATION);
export const isActiveExpandImageModal = createAction(ACTIVE_EXPANDIMAGE);
export const expandImageUrl = createAction(EXPANDIMAGE_URL);
export const expandImageAlt = createAction(EXPANDIMAGE_ALT);
export const loading = createAction(LOADING);
export const isActiveAdditionalModal = createAction(ACTIVE_ADDITIONAL);
export const isActiveSosongGuideModal = createAction(ACTIVE_SOSONG_GUIDE);
export const isActiveSosongFlowChartModal = createAction(ACTIVE_SOSONG_FLOWCHART);
export const isActiveSosongTermSearch = createAction(ACTIVE_TERM_SEARCH);
export const isActiveSendBtn = createAction(ACTIVE_SEND_BTN);




export const disableAllMenu = createAction(DISABLE_ALL_MENU);
// const initialState = false;
const initialState = {
  settingMenu: false,
  sideMenu: false,
  quickMenu: false,
  feedbackModal: false,
  feedbackResponseModal: false,
  satisfyModal: false,
  conversationGuideModal: false,
  serviceGuideModal: false,
  organizationModal: false,
  expandImageModal: false,
  expandImageUrl: '',
  expandImageAlt:'',
  initialModal: false,
  exitModal:false,
  loading: false,
  additionalModal: false,
  sosongGuideModal: false,
  sosongFlowChartModal: false,
  sosongTermSearch: false,
  sendBtn: false,
};
const isActive = handleActions(
  {
    [EXPANDIMAGE_URL]: (state, action) => {
      return { ...state, expandImageUrl: action.payload };
    },
    [EXPANDIMAGE_ALT]: (state, action) => {
      return { ...state, expandImageAlt: action.payload };
    },
    [ACTIVE_EXPANDIMAGE]: (state, action) => {
      return { ...state, expandImageModal: action.payload };
    },
    [ACTIVE_ADDITIONAL]: state => ({ ...state, additionalModal: !state.additionalModal }),
    [ACTIVE_SOSONG_GUIDE]: state => ({ ...state, sosongGuideModal: !state.sosongGuideModal }),
    [ACTIVE_SOSONG_FLOWCHART]: state => ({ ...state, sosongFlowChartModal: !state.sosongFlowChartModal }),
    [ACTIVE_TERM_SEARCH]: state => ({ ...state, sosongTermSearch: !state.sosongTermSearch }),
    [ACTIVE_ORGANIZATION]: (state, action) => ({ ...state, organizationModal: action.payload }),
    [ACTIVE_CONVERSATION_GUIDE]: state => ({ ...state, conversationGuideModal: !state.conversationGuideModal }),
    [ACTIVE_SERVICE_GUIDE]: state => ({ ...state, serviceGuideModal: !state.serviceGuideModal }),
    [ACTIVE_SETTING_MENU]: state => ({ ...state, settingMenu: !state.settingMenu }),
    [ACTIVE_SIDE_MENU]: state => ({ ...state, sideMenu: !state.sideMenu }),
    [ACTIVE_QUICK_MENU]: state => ({ ...state, quickMenu: !state.quickMenu }),
    [ACTIVE_FEEDBACK_MODAL]: state => ({ ...state, feedbackModal: !state.feedbackModal }), 
    [ACTIVE_FEEDBACK_RESPONSE_MODAL]: state => ({ ...state, feedbackResponseModal: !state.feedbackResponseModal }),
    [ACTIVE_INITIAL_MODAL]: state => ({ ...state, initialModal: !state.initialModal }),
    [ACTIVE_EXIT_MODAL]: state => ({ ...state, exitModal: !state.exitModal }),
    [ACTIVE_SATISFY_MODAL]: state => ({ ...state, satisfyModal: !state.satisfyModal }),
    [ACTIVE_SEND_BTN]: state => ({ ...state, sendBtn: !state.sendBtn }),
    [LOADING]: (state, action) => ({ ...state, loading: action.payload }),
    [ACTIVE_MODAL]: (state, action) => {
      for (const key of Object.keys(state)) {
        if(key === 'feedbackModal' && state[key] === true) {
          state[key] = true;
        } else {
          state[key] = false;
        }
      }

      return {
        ...state,
        [action.payload]: true,
      };
    },
    [DISABLE_ALL_MENU]: state => initialState,
  },
  initialState
);

export default isActive;
